module.exports = __webpack_public_path__ + "media/icons/time-off-b6bd15e0.svg";